module.exports = __webpack_public_path__ + "static/img/target-oxbridge-october-2019.ba5deab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/target-oxbridge-october-2019.jpg
// module id = sp9e
// module chunks = 0